<template>
  <div>
    <div class="product-quantity d-flex justify-content-between align-items-center">
      <div
        class="d-flex justify-content-center align-items-center"
        style="width: 160px; color: #3b71de"
      >
        <span class="input-group-btn">
          <button 
            class="btn btn-number" 
            type="button"
            data-type="minus" 
            data-field="quantity"
            :disabled="value < 1 || disabled" 
            style="padding: 10px;color: #3b71de"
            @click="minus"
          >
            -
          </button>
        </span>

        <input 
          v-model.number="value" 
          type="text" 
          :min="min" 
          :max="max" 
          :disabled="disabled"
          autocomplete="off"
          class="form-control input-number text-center cart-qty-field"
        />

        <span class="input-group-btn">
          <button 
            class="btn btn-number" 
            type="button" 
            data-type="plus"
            :disabled="value >= max || disabled" 
            data-field="quantity" 
            style="padding: 10px;color: #3b71de"
            @click="plus"
          >
            +
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useVModel } from '@vueuse/core'

const props = defineProps ({
  modelValue: {
    type: [Number, String],
    default: 0,
  },
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])
const value = useVModel(props, 'modelValue', emit)
value.value = Number(value.value)



const minus = () => {
  value.value--
  if (value.value > props.max) {
    value.value = props.max
  }
}
const plus = () => {
  value.value++
  if (value.value < props.min) {
    value.value = props.min
  }
}
</script>
